import React, { useEffect, useState } from "react";
import PDFPreview from "./PDFPreview/PDFPreview";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { RiZoomInLine, RiZoomOutLine } from "react-icons/ri";
import { CircularProgress } from "@mui/material";

const Modal = ({ isOpen, onClose, pdf, keyword, pageNumber, uuid }) => {
  const [currentPageNumber, setPageNumber] = useState(pageNumber);
  const [maxPageNumber, setMaxPageNumber] = useState(null);
  const [scale, setScale] = useState(0.6);
  const [modalWidth, setModalWidth] = useState(30);
  const [inputPageNumber, setInputPageNumber] = useState(pageNumber);

  useEffect(() => {
    if (isOpen) {
      setPageNumber(pageNumber);
      setInputPageNumber(pageNumber);
    }
  }, [isOpen, pageNumber]);

  if (!isOpen) return null;

  const onPrevious = () => {
    if (currentPageNumber > 1) {
      const number = currentPageNumber - 1;
      setPageNumber(number);
      setInputPageNumber(number);
    }
  };

  const onNext = () => {
    if (currentPageNumber < maxPageNumber) {
      const number = currentPageNumber + 1;
      setPageNumber(number);
      setInputPageNumber(number);
    }
  };

  const closeAndResetScale = () => {
    setScale(0.6);
    setModalWidth(30);
    onClose();
  };

  const onScaleIncrease = () => {
    setScale((prevScale) => {
      const newScale = Math.min(prevScale + 0.1, 2);
      setModalWidth((prevWidth) => Math.min(prevWidth * 1.1, 100));
      return newScale;
    });
  };

  const onScaleDecrease = () => {
    setScale((prevScale) => {
      const newScale = Math.max(prevScale - 0.1, 0.3);
      setModalWidth((prevWidth) => Math.max(prevWidth * 0.9, 10));
      return newScale;
    });
  };

  // Handle key press (Enter key to update the page)
  const onPageNumberKeyPress = (e) => {
    if (e.key === "Enter") {
      const value = Number(inputPageNumber);
      if (value > 0 && value <= maxPageNumber) {
        setPageNumber(value);
      } else {
        setInputPageNumber(currentPageNumber);
      }
    }
  };

  return (
    <div
      className="modal-overlay"
      onClick={() => {
        closeAndResetScale();
      }}
    >
      {pdf ? (
        <>
          <button
            className="navigation-button previous"
            onClick={(e) => {
              e.stopPropagation();
              onPrevious();
            }}
            disabled={currentPageNumber === pageNumber}
          >
            <FaAngleLeft />
          </button>
          <div
            className="modal-content"
            style={{ width: `${modalWidth}%` }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="button-container">
              <div className="center-buttons">
                <div className="controller" style={{ width: `30%` }}>
                  <div className="zoom-btn">
                    <button
                      className="center-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        onScaleIncrease();
                      }}
                    >
                      <RiZoomInLine />
                    </button>

                    <button
                      className="center-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        onScaleDecrease();
                      }}
                    >
                      <RiZoomOutLine />
                    </button>
                  </div>
                  <div className="page-controller">
                    <input
                      className="preview-page-controller-input"
                      type="number"
                      value={inputPageNumber}
                      min={1}
                      max={maxPageNumber}
                      onChange={(e) => setInputPageNumber(e.target.value)}
                      onKeyDown={onPageNumberKeyPress}
                    />
                    &nbsp;/&nbsp;{maxPageNumber}
                  </div>
                </div>
              </div>
            </div>

            <PDFPreview
              pdf={pdf}
              query={keyword}
              defaultPage={currentPageNumber}
              onLoadSuccess={(numPages) => setMaxPageNumber(numPages)}
              scale={scale}
            />
          </div>
          <button
            className="navigation-button next"
            onClick={(e) => {
              e.stopPropagation();
              onNext();
            }}
            disabled={currentPageNumber >= maxPageNumber}
          >
            <FaAngleRight />
          </button>
        </>
      ) : (
        <div className="loading-container">
          <div className="circular-progress"></div>
          <p style={{ color: "white", fontSize: "16px" }}>Opening PDF</p>&nbsp;
          <CircularProgress />
        </div>
      )}
    </div>
  );
};

export default Modal;
